import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errText, mediaUrl } from "../lib/api";
import { Loading, Empty, formatNum } from "../components/common";
import { downloadProduct } from "../components/marketui";
import { Library, Download, ShoppingCart, Package } from "lucide-react";
import { toast } from "sonner";

export default function BuyerLibrary() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/marketplace/purchases").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);

  const dl = async (pid) => { try { await downloadProduct(pid); } catch (e) { toast.error(errText(e)); } };

  if (items === null) return <Loading />;
  return (
    <div className="px-4 md:px-6 py-5 max-w-[900px] mx-auto" data-testid="library-page">
      <div className="flex items-center justify-between gap-3 mb-5 flex-wrap">
        <div>
          <h1 className="font-display font-extrabold text-2xl md:text-3xl flex items-center gap-2"><Library className="text-eblue" size={26} />My Purchases</h1>
          <p className="text-sm text-muted-foreground mt-1">Every product you own — re-download anytime.</p>
        </div>
        <Link to="/marketplace" className="btn-blue rounded-full px-4 h-10 flex items-center gap-2 text-sm font-semibold"><ShoppingCart size={16} />Browse Marketplace</Link>
      </div>

      {items.length === 0 ? (
        <Empty icon={Package} title="No purchases yet" hint="Products you buy on the Marketplace show up here for re-download." />
      ) : (
        <div className="space-y-3">
          {items.map((p) => (
            <div key={p.id} className="surface rounded-2xl p-3 flex items-center gap-3" data-testid={`library-item-${p.id}`}>
              <div className="w-16 h-16 rounded-lg bg-black/40 overflow-hidden shrink-0">{p.preview_images?.[0] ? <img src={mediaUrl(p.preview_images[0])} className="w-full h-full object-cover" alt="" /> : <div className="w-full h-full flex items-center justify-center text-muted-foreground"><Package size={22} /></div>}</div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold truncate">{p.name}</div>
                <div className="text-[11px] text-muted-foreground">by @{p.seller?.username} · {new Date(p.acquired_at).toLocaleDateString()}{p.price > 0 ? ` · ${formatNum(p.price)} VC` : " · Free"}</div>
                {p.platforms?.length > 0 && <div className="text-[10px] text-muted-foreground truncate mt-0.5">{p.platforms.join(" · ")}</div>}
              </div>
              {p.has_file ? (
                <button onClick={() => dl(p.id)} data-testid={`library-download-${p.id}`} className="btn-blue rounded-full px-4 h-9 text-sm font-semibold flex items-center gap-1.5 shrink-0"><Download size={15} />Download</button>
              ) : <span className="text-xs text-muted-foreground shrink-0">No file</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
